module.exports = __webpack_public_path__ + "media/luxury-2026/billiard-room-960-222b6fba.jpg";